import { AgChartTheme } from 'ag-charts-community';

export enum CHART_COLORS {
    primary = '#175c89',
    secondary = '#0095ff',
    tertiary = '#85b1ce',
    quaternary = '#98b7d2',
    black = '#000000',
    text = '#333333',
    axes = '#999999',
    rates = '#032B44'
}

export enum CHART_FONTS {
    Roboto = 'Roboto'
}

export enum CHART_BORDER_RADIUS {
    primary = 4,
    secondary = 8,
    tertiary = 12
}

function getResponsiveFontSize(base: number): number {
    let size = base;

    if (window.innerWidth > 1921) {
        if (base === 8) size = 12;
        else if (base === 12) size = 14;
        else if (base === 14) size = 16;
        else if (base === 16) size = 18;
    }

    return size;
}

export const customTheme: AgChartTheme = {
    palette: {
        fills: [CHART_COLORS.primary, CHART_COLORS.secondary, CHART_COLORS.tertiary],
        strokes: [CHART_COLORS.primary]
    },
    overrides: {
        common: {
            title: {
                textAlign: 'left',
                fontFamily: CHART_FONTS.Roboto,
                fontWeight: 500,
                color: CHART_COLORS.text,
                fontSize: getResponsiveFontSize(16)
            },
            subtitle: {
                textAlign: 'left',
                fontFamily: CHART_FONTS.Roboto,
                color: CHART_COLORS.secondary
            },
            animation: {
                enabled: true
            },
            axes: {
                number: {
                    title: {
                        fontFamily: CHART_FONTS.Roboto,
                        color: CHART_COLORS.text
                    },
                    label: {
                        fontFamily: CHART_FONTS.Roboto,
                        color: CHART_COLORS.axes,
                        fontSize: getResponsiveFontSize(8)
                    }
                },
                category: {
                    label: {
                        fontFamily: CHART_FONTS.Roboto,
                        color: CHART_COLORS.text,
                        fontSize: getResponsiveFontSize(12)
                    }
                }
            },
            legend: {
                position: 'left',
                item: {
                    label: {
                        fontFamily: CHART_FONTS.Roboto,
                        fontSize: getResponsiveFontSize(12),
                        color: CHART_COLORS.text
                    },
                    marker: {
                        shape: 'circle',
                        size: 10
                    }
                }
            }
        },
        bar: {
            series: {
                cornerRadius: CHART_BORDER_RADIUS.primary,
                label: {
                    placement: 'outside',
                    fontFamily: CHART_FONTS.Roboto,
                    fontWeight: 400,
                    color: CHART_COLORS.text
                }
            }
        }
    }
};

export const reportsSingleChart: AgChartTheme = {
    palette: {
        fills: ['#36A2EB', '#FF6384', '#CF77EC', '#EF8132'],
        strokes: ['#36A2EB', '#FF6384', '#CF77EC', '#EF8132']
    },
    overrides: {
        common: {
            title: {
                textAlign: 'left',
                spacing: 50,
                fontFamily: CHART_FONTS.Roboto,
                fontWeight: 600,
                fontSize: 20,
                color: CHART_COLORS.primary
            },
            subtitle: {
                textAlign: 'left',
                fontFamily: CHART_FONTS.Roboto,
                color: CHART_COLORS.secondary
            },
            animation: {
                enabled: true
            },
            axes: {
                number: {
                    title: {
                        fontFamily: CHART_FONTS.Roboto,
                        color: '#777',
                        fontSize: getResponsiveFontSize(14)
                    },
                    label: {
                        fontFamily: CHART_FONTS.Roboto,
                        color: '#777',
                        fontSize: getResponsiveFontSize(14)
                    }
                },
                category: {
                    label: {
                        fontFamily: CHART_FONTS.Roboto,
                        color: '#777',
                        fontSize: getResponsiveFontSize(14)
                    }
                }
            },
            legend: {
                position: 'top',
                item: {
                    label: {
                        fontFamily: CHART_FONTS.Roboto,
                        fontSize: getResponsiveFontSize(14)
                    }
                }
            }
        },
        line: {
            series: {
                marker: {
                    enabled: false
                }
            },
            legend: {
                item: {
                    line: {
                        strokeWidth: 16,
                        length: 42
                    }
                }
            }
        }
    }
};
